import React from 'react';
import '../template-file-css/document-file-template.css';


export const TPCS_IddGoalSheet = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='TPCS_IddGoalSheet' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'><center>KEY 1 (Intervention Key)</center></span></td>
                        <td className='w-375'><span className='eleHeader'><center>KEY 2 (Assessment Key)</center></span></td>
                    </tr>
                    <tr>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-50'>

                            <b>N/A</b>
                            <br />
                            <b>I</b>
                            <br />
                            <b>VP</b>
                            <br />
                            <b>G</b>
                            <br />
                            <b>M</b>
                            <br />
                            <b>PP</b>
                            <br />
                            <b>FP</b>
                        </td>
                        <td className='w-300'>
                            Non-Applicable
                            <br />
                            Independent
                            <br />
                            Verbal Prompt
                            <br />
                            Gesture
                            <br />
                            Model
                            <br />
                            Partial Physical Prompt
                            <br />
                            <b>FP</b> Full Physical Prompt
                        </td>

                        <td className='w-25'>&nbsp;</td>
                        <td className='w-50'>

                            <b>N/A</b>
                            <br />
                            <b>Y</b>
                            <br />
                            <b>N</b>
                            <br />
                            <b>R</b>
                        </td>
                        <td className='w-300'>
                            Non-Applicable
                            <br />
                            Yes
                            <br />
                            No
                            <br />
                            Refused

                        </td>
                    </tr>

                </table>

                <p className='w-750'><h4>OutCome</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 1</span>
                    <textarea id='txtGoalId_1' name='txtGoalId_1' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_1' name='ddlInterventionSun_1' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_2' name='ddlInterventionMon_2' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_3' name='ddlInterventionTues_3' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_4' name='ddlInterventionWed_4' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_5' name='ddlInterventionThurs_5' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_6' name='ddlInterventionFri_6' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_7' name='ddlInterventionSat_7' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_1' name='ddlAssessmentSun_1' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_2' name='ddlAssessmentMon_2' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_3' name='ddlAssessmentTues_3' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_4' name='ddlAssessmentWed_4' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_5' name='ddlAssessmentThurs_5' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_6' name='ddlAssessmentFri_6' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_7' name='ddlAssessmentSat_7' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>

                    </tr>

                </table>




                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 2</span>
                    <textarea id='txtGoalId_2' name='txtGoalId_2' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_8' name='ddlInterventionSun_8' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_9' name='ddlInterventionMon_9' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_10' name='ddlInterventionTues_10' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_11' name='ddlInterventionWed_11' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_12' name='ddlInterventionThurs_12' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_13' name='ddlInterventionFri_13' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_14' name='ddlInterventionSat_14' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_8' name='ddlAssessmentSun_8' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_9' name='ddlAssessmentMon_9' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_10' name='ddlAssessmentTues_10' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_11' name='ddlAssessmentWed_11' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_12' name='ddlAssessmentThurs_12' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_13' name='ddlAssessmentFri_13' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_14' name='ddlAssessmentSat_14' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>

                    </tr>

                </table>



                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 3</span>
                    <textarea id='txtGoalId_3' name='txtGoalId_3' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_15' name='ddlInterventionSun_15' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_16' name='ddlInterventionMon_16' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_17' name='ddlInterventionTues_17' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_18' name='ddlInterventionWed_18' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_19' name='ddlInterventionThurs_19' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_20' name='ddlInterventionFri_20' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_21' name='ddlInterventionSat_21' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_15' name='ddlAssessmentSun_15' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_16' name='ddlAssessmentMon_16' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_17' name='ddlAssessmentTues_17' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_18' name='ddlAssessmentWed_18' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_19' name='ddlAssessmentThurs_19' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_20' name='ddlAssessmentFri_20' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_21' name='ddlAssessmentSat_21' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>

                    </tr>

                </table>



                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 4</span>
                    <textarea id='txtGoalId_4' name='txtGoalId_4' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_22' name='ddlInterventionSun_22' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_23' name='ddlInterventionMon_23' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_24' name='ddlInterventionTues_24' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_25' name='ddlInterventionWed_25' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_26' name='ddlInterventionThurs_26' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_27' name='ddlInterventionFri_27' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_28' name='ddlInterventionSat_28' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_22' name='ddlAssessmentSun_22' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_23' name='ddlAssessmentMon_23' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_24' name='ddlAssessmentTues_24' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_25' name='ddlAssessmentWed_25' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_26' name='ddlAssessmentThurs_26' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_27' name='ddlAssessmentFri_27' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_28' name='ddlAssessmentSat_28' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                    </tr>
                </table>



                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 5</span>
                    <textarea id='txtGoalId_5' name='txtGoalId_5' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_29' name='ddlInterventionSun_29' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_30' name='ddlInterventionMon_30' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_31' name='ddlInterventionTues_31' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_32' name='ddlInterventionWed_32' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_33' name='ddlInterventionThurs_33' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_34' name='ddlInterventionFri_34' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_35' name='ddlInterventionSat_35' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_29' name='ddlAssessmentSun_29' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_30' name='ddlAssessmentMon_30' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_31' name='ddlAssessmentTues_31' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_32' name='ddlAssessmentWed_32' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_33' name='ddlAssessmentThurs_33' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_34' name='ddlAssessmentFri_34' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_35' name='ddlAssessmentSat_35' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 6</span>
                    <textarea id='txtGoalId_6' name='txtGoalId_6' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_36' name='ddlInterventionSun_36' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_37' name='ddlInterventionMon_37' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_38' name='ddlInterventionTues_38' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_39' name='ddlInterventionWed_39' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_40' name='ddlInterventionThurs_40' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_41' name='ddlInterventionFri_41' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_42' name='ddlInterventionSat_42' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_36' name='ddlAssessmentSun_36' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_37' name='ddlAssessmentMon_37' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_38' name='ddlAssessmentTues_38' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_39' name='ddlAssessmentWed_39' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_40' name='ddlAssessmentThurs_40' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_41' name='ddlAssessmentFri_41' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_42' name='ddlAssessmentSat_42' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 7</span>
                    <textarea id='txtGoalId_7' name='txtGoalId_7' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_43' name='ddlInterventionSun_43' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_44' name='ddlInterventionMon_44' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_45' name='ddlInterventionTues_45' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_46' name='ddlInterventionWed_46' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_47' name='ddlInterventionThurs_47' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_48' name='ddlInterventionFri_48' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_49' name='ddlInterventionSat_49' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_43' name='ddlAssessmentSun_43' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_44' name='ddlAssessmentMon_44' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_45' name='ddlAssessmentTues_45' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_46' name='ddlAssessmentWed_46' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_47' name='ddlAssessmentThurs_47' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_48' name='ddlAssessmentFri_48' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_49' name='ddlAssessmentSat_49' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 8</span>
                    <textarea id='txtGoalId_8' name='txtGoalId_8' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_50' name='ddlInterventionSun_50' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_51' name='ddlInterventionMon_51' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_52' name='ddlInterventionTues_52' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_53' name='ddlInterventionWed_53' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_54' name='ddlInterventionThurs_54' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_55' name='ddlInterventionFri_55' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_56' name='ddlInterventionSat_56' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_50' name='ddlAssessmentSun_50' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_51' name='ddlAssessmentMon_51' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_52' name='ddlAssessmentTues_52' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_53' name='ddlAssessmentWed_53' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_54' name='ddlAssessmentThurs_54' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_55' name='ddlAssessmentFri_55' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_56' name='ddlAssessmentSat_56' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                    </tr>


                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 9</span>
                    <textarea id='txtGoalId_9' name='txtGoalId_9' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_57' name='ddlInterventionSun_57' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_58' name='ddlInterventionMon_58' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_59' name='ddlInterventionTues_59' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_60' name='ddlInterventionWed_60' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_61' name='ddlInterventionThurs_61' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_62' name='ddlInterventionFri_62' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_63' name='ddlInterventionSat_63' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_57' name='ddlAssessmentSun_57' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_58' name='ddlAssessmentMon_58' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_59' name='ddlAssessmentTues_59' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_60' name='ddlAssessmentWed_60' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_61' name='ddlAssessmentThurs_61' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_62' name='ddlAssessmentFri_62' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_63' name='ddlAssessmentSat_63' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                    </tr>
                </table>




                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 10</span>
                    <textarea id='txtGoalId_10' name='txtGoalId_10' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_64' name='ddlInterventionSun_64' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_65' name='ddlInterventionMon_65' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_66' name='ddlInterventionTues_66' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_67' name='ddlInterventionWed_67' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_68' name='ddlInterventionThurs_68' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_69' name='ddlInterventionFri_69' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_70' name='ddlInterventionSat_70' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_64' name='ddlAssessmentSun_64' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_65' name='ddlAssessmentMon_65' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_66' name='ddlAssessmentTues_66' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_67' name='ddlAssessmentWed_67' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_68' name='ddlAssessmentThurs_68' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_69' name='ddlAssessmentFri_69' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_70' name='ddlAssessmentSat_70' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 11</span>
                    <textarea id='txtGoalId_11' name='txtGoalId_11' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_71' name='ddlInterventionSun_71' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_72' name='ddlInterventionMon_72' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_73' name='ddlInterventionTues_73' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_74' name='ddlInterventionWed_74' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_75' name='ddlInterventionThurs_75' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_76' name='ddlInterventionFri_76' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_77' name='ddlInterventionSat_77' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_71' name='ddlAssessmentSun_71' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_72' name='ddlAssessmentMon_72' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_73' name='ddlAssessmentTues_73' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_74' name='ddlAssessmentWed_74' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_75' name='ddlAssessmentThurs_75' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_76' name='ddlAssessmentFri_76' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_77' name='ddlAssessmentSat_77' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Goal ID: 12</span>
                    <textarea id='txtGoalId_12' name='txtGoalId_12' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-90'><span className='eleHeader'>Key:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sun:</span></td>
                        <td className='w-90'><span className='eleHeader'>Mon:</span></td>
                        <td className='w-90'><span className='eleHeader'>Tues:</span></td>
                        <td className='w-90'><span className='eleHeader'>Wed:</span></td>
                        <td className='w-90'><span className='eleHeader'>Thurs:</span></td>
                        <td className='w-90'><span className='eleHeader'>Fri:</span></td>
                        <td className='w-90'><span className='eleHeader'>Sat:</span></td>
                    </tr>

                    <tr>
                        <td className='w-90'>KEY 1 (Intervention Key)</td>
                        <td className='w-90'>
                            <select id='ddlInterventionSun_78' name='ddlInterventionSun_78' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionMon_79' name='ddlInterventionMon_79' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionTues_80' name='ddlInterventionTues_80' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionWed_81' name='ddlInterventionWed_81' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP </option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionThurs_82' name='ddlInterventionThurs_82' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionFri_83' name='ddlInterventionFri_83' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'> M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlInterventionSat_84' name='ddlInterventionSat_84' className='add-only'>
                                <option value='N/A'>N/A</option>
                                <option value='I'>I</option>
                                <option value='VP'>VP</option>
                                <option value='G'>G</option>
                                <option value='M'>M</option>
                                <option value='PP'>PP</option>
                                <option value='FP'>FP</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-90'>KEY 2 (Assessment Key)</td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSun_78' name='ddlAssessmentSun_78' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentMon_79' name='ddlAssessmentMon_79' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentTues_80' name='ddlAssessmentTues_73' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentWed_81' name='ddlAssessmentWed_81' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentThurs_82' name='ddlAssessmentThurs_82' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentFri_83' name='ddlAssessmentFri_83' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                        <td className='w-90'>
                            <select id='ddlAssessmentSat_84' name='ddlAssessmentSat_84' className='add-only'>
                                <option value='NA'>N/A</option>
                                <option value='Y'>Yes</option>
                                <option value='N'>No</option>
                                <option value='R'>Refused</option>
                            </select>
                        </td>
                    </tr>
                </table> <br />


                <p className='w-750'><h4>TIME IN/TIME OUT</h4></p>


                <table>
                    <tr>
                        <td className='w-60'> &nbsp; </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Time In</span></td>
                        <td className='w-125'>
                            <span className='eleHeader'>Time Out</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>DURATION</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>DATE</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>TRAINER INITIALS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-60'>
                            <b>Sun:</b></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeIn_1' name='txtTimeIn_1' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeOut_1' name='txtTimeOut_1' className='add-only' />
                        </td>
                        <td className='w-140'> <input type='text' id='txtDuration_1' name='txtDuration_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_1' name='txtDate_1' className='add-only' /></td>
                        <td className='w-150'> <input type='text' id='txtTrainerInitials_1' name='txtTrainerInitials_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-60'>
                            <b>Mon:</b></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeIn_2' name='txtTimeIn_2' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeOut_2' name='txtTimeOut_2' className='add-only' />
                        </td>
                        <td className='w-140'> <input type='text' id='txtDuration_2' name='txtDuration_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_2' name='txtDate_2' className='add-only' /></td>
                        <td className='w-150'> <input type='text' id='txtTrainerInitials_2' name='txtTrainerInitials_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-60'>
                            <b>Tues:</b></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeIn_3' name='txtTimeIn_3' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeOut_3' name='txtTimeOut_3' className='add-only' />
                        </td>
                        <td className='w-140'> <input type='text' id='txtDuration_3' name='txtDuration_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_3' name='txtDate_3' className='add-only' /></td>
                        <td className='w-150'> <input type='text' id='txtTrainerInitials_3' name='txtTrainerInitials_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-60'>
                            <b>Wed:</b></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeIn_4' name='txtTimeIn_4' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeOut_4' name='txtTimeOut_4' className='add-only' />
                        </td>
                        <td className='w-140'> <input type='text' id='txtDuration_4' name='txtDuration_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_4' name='txtDate_4' className='add-only' /></td>
                        <td className='w-150'> <input type='text' id='txtTrainerInitials_4' name='txtTrainerInitials_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-60'>
                            <b>Thurs:</b></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeIn_5' name='txtTimeIn_5' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeOut_5' name='txtTimeOut_5' className='add-only' />
                        </td>
                        <td className='w-140'> <input type='text' id='txtDuration_5' name='txtDuration_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_5' name='txtDate_5' className='add-only' /></td>
                        <td className='w-150'> <input type='text' id='txtTrainerInitials_5' name='txtTrainerInitials_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-60'>
                            <b>Fri:</b></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeIn_6' name='txtTimeIn_6' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeOut_6' name='txtTimeOut_6' className='add-only' />
                        </td>
                        <td className='w-140'> <input type='text' id='txtDuration_6' name='txtDuration_6' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_6' name='txtDate_6' className='add-only' /></td>
                        <td className='w-150'> <input type='text' id='txtTrainerInitials_6' name='txtTrainerInitials_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-60'>
                            <b>Sat:</b></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeIn_7' name='txtTimeIn_7' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='time' id='txtTimeOut_7' name='txtTimeOut_7' className='add-only' />
                        </td>
                        <td className='w-140'> <input type='text' id='txtDuration_7' name='txtDuration_7' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_7' name='txtDate_7' className='add-only' /></td>
                        <td className='w-150'> <input type='text' id='txtTrainerInitials_7' name='txtTrainerInitials_7' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Date</span></td>
                        <td className='w-600'>
                            <span className='eleHeader'>Comments</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_8' name='txtDate_8' className='add-only' /></td>
                        <td className='w-600'>
                            <input type='text' id='txtComments_1' name='txtComments_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_9' name='txtDate_9' className='add-only' /></td>
                        <td className='w-600'>
                            <input type='text' id='txtComments_2' name='txtComments_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_10' name='txtDate_10' className='add-only' /></td>
                        <td className='w-600'>
                            <input type='text' id='txtComments_3' name='txtComments_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_11' name='txtDate_11' className='add-only' /></td>
                        <td className='w-600'>
                            <input type='text' id='txtComments_4' name='txtComments_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_12' name='txtDate_12' className='add-only' /></td>
                        <td className='w-600'>
                            <input type='text' id='txtComments_5' name='txtComments_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_13' name='txtDate_13' className='add-only' /></td>
                        <td className='w-600'>
                            <input type='text' id='txtComments_6' name='txtComments_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_14' name='txtDate_14' className='add-only' /></td>
                        <td className='w-600'>
                            <input type='text' id='txtComments_7' name='txtComments_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_15' name='txtDate_15' className='add-only' /></td>
                        <td className='w-600'>
                            <input type='text' id='txtComments_8' name='txtComments_8' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h4>ALL STAFF PERSONS WORKING WITH THER CLIENT MUST FILL OUT INFORMATION BELOW</h4></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>STAFF NAME (PRINT)</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>INITIALS</span>
                        </td>
                        <td className='w-250'><span className='eleHeader'>STAFF SIGNATURE & TITLE</span>  </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStaffName' name='txtStaffName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtInitials' name='txtInitials' className='add-only' />
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>QP SIGNATURE: </td>
                        <td className='small w-250'>Date</td>
                        <td className='small w-250'>TOTAL HOURS:</td>
                    </tr>
                </table> 




            </div>
        </form >

    )
}











